export function useApiClient() {
  const { BASE_URL, TOKEN } = useRuntimeConfig().public;
  const base = useRuntimeConfig().app.baseURL || '';

  const client = $fetch.create({
    baseURL: `${base}api/payments`,
    retry: 0,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': TOKEN as string,
    },
    onResponse({ response }) {
      if (response.status === 204 || response.headers.get('Content-Length') === '0') {
        response._data = null;
      }
    },
    onResponseError({ response }) {
      throw {
        ...response._data,
        status: response.status,
      };
    },
  });

  async function get(url: string, options?: { timeout?: number }): Promise<any> {
    if (!BASE_URL) {
      throw new Error('BASE_URL is not defined in runtimeConfig');
    }

    return await client(url, { method: 'GET', ...options });
  }

  async function post(url: string, body: any, options?: { timeout?: number }): Promise<any> {
    if (!BASE_URL) {
      throw new Error('BASE_URL is not defined in runtimeConfig');
    }

    return await client(url, { method: 'POST', body, ...options });
  }

  return { get, post };
}
